import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import Background from 'components/common/Background';
import corner4 from 'assets/img/illustrations/corner-4.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Input from 'components/common/Input';

const Qualities = ({ watch, setValue, register, errors }) => {
 return (
  <Card className="mb-3">
   <Background
    image={corner4}
    className="bg-card"
    style={{
     borderTopRightRadius: '0.375rem',
     borderBottomRightRadius: '0.375rem'
    }}
   />
   <Card.Body className="bg-100 fs--1">
    <div className="mb-3">
     <h5 className="mb-0 text-primary position-relative">
      <FontAwesomeIcon icon="plus" className="text-primary" />
      <span className="bg-100 dark__bg-1100 pe-3 ms-1">Caracteristicas</span>
      <span className="border position-absolute top-50 translate-middle-y w-100 start-0 z-index--1"></span>
     </h5>
     <p className="mb-0">estipule las características que podrían describir un proyecto por las ventajas que este ofrece</p>
    </div>
    <Input
     type="list"
     name="quality"
     errors={errors}
     placeholder="Nueva cualidad"
     options={[...(watch('qualities') || [])]}
     formGroupProps={{
      className: 'flex-fill mb-1'
     }}
     formControlProps={{
      rows: 2,
      size: 'sm',
      className: 'pe-6',
      style: { maxHeight: 300 },
      onChange: items => setValue('qualities', items.length ? items : []),
      register: register('qualities', {
       required: true,
       validate: value => value.length || 'Debe establecer al menos una caracteristica'
      })
     }}
    />
   </Card.Body>
  </Card>
 );
};

Qualities.propTypes = { watch: PropTypes.func, setValue: PropTypes.func, register: PropTypes.func, errors: PropTypes.object };

export default Qualities;
